<template>
    <div class="login-layout" :class="`theme-${theme}`">
        <!-- <div @click="isDark = !isDark"
            class="d-flex align-items-center btn btn-sm btn-outline-secondary ms-3 position-absolute"
            style="top: 1rem; right: 1rem; z-index: 10">
            <span class="material-symbols-outlined">
                {{ isDark ? 'light_mode' : 'dark_mode' }}
            </span>
        </div> -->
        <!-- Left -->
        <div class="login-main">
            <!-- Login Logo -->
            <div class="login-logo">
                <img src="@/assets/images/login-logo.png" alt="Login logo">
            </div>
            <!-- Login Title-->
            <div class="login-title">
                <h1>Planning And Budgeting System</h1>
                <p>Please sign in to your OGPABS account</p>
            </div>
            <!-- Login Form -->
            <div class="login-form">
                <div class="form-outer">
                    <form @submit.prevent="handleSubmit">

                        <div v-if="errorMessage" class="error-message">
                            {{ errorMessage }}
                        </div>

                        <div class="form-group">
                            <label for="username">Username</label><br />
                            <input id="email" v-model="email" type="email" placeholder="username"
                                @input="clearErrorMessage" required />
                        </div>
                        <div class="form-group">
                            <label for="password">Password</label><br />
                            <input id="password" v-model="password" :type="passwordVisible ? 'text' : 'password'"
                                placeholder="********" @input="clearErrorMessage" required />
                            <span class="toggle-password" @click="togglePasswordVisibility">
                                <i :class="toggleIconClass" id="toggleIcon"></i>
                            </span>
                        </div>
                        <div class="forgot-password">
                            <router-link to="/forgot-password">Forgot Password?</router-link>
                        </div>
                        <button type="submit" class="sign-in-btn" :disabled="isLoading">
                            <span v-if="isLoading">
                                <i class="fas fa-spinner fa-spin"></i> Signing In...
                            </span>
                            <span v-else>
                                Sign In
                            </span>
                        </button>
                    </form>
                </div>
            </div>
            <!-- Footer -->
            <footer>
                <div>
                    <p>© 2025-{{ currentYear }} Powered by Tinovo Technology Services.</p>
                </div>
            </footer>
        </div>

        <!-- Right -->
        <div class="login-image">
            <img src="@/assets/images/login-image-removebg.png" alt="Login image">
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import '@/assets/css/login.css'
import Cookies from 'js-cookie'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useTheme } from '@/composables/useTheme'
const { theme } = useTheme()

onMounted(() => {
    document.title = "Login"
})

// 📦 Reactive State
const email = ref('')
const password = ref('')
const errorMessage = ref('')
const passwordVisible = ref(false)
const isLoading = ref(false)
const router = useRouter()
const userStore = useUserStore()

// 👁 Toggle Eye Icon
const toggleIconClass = computed(() =>
    passwordVisible.value ? 'far fa-eye-slash' : 'far fa-eye'
)

const currentYear = new Date().getFullYear()

// 💡 Methods
function clearErrorMessage() {
    errorMessage.value = ''
}

function togglePasswordVisibility() {
    passwordVisible.value = !passwordVisible.value
}

async function handleSubmit() {
    isLoading.value = true
    errorMessage.value = ''
    const root_api_url = process.env.VUE_APP_API_ROOT_URL

    try {
        const result = await axios.post(`${root_api_url}/auth/authenticate`, {
            email: email.value,
            password: password.value
        })

        if (result.status === 200) {
            Cookies.set('auth_token', result.data.token, { expires: 1, path: '/' })
            userStore.setToken(result.data.token)
            await userStore.fetchProfile()
            await userStore.fetchProfilePhoto()
            await userStore.fetchSignature()
            router.push({ name: 'Dashboard' })
        }
    } catch (err) {
        if (err?.response?.status === 417) {
            errorMessage.value = err.response.data.errorMessage
        } else if (err?.response?.status === 503) {
            errorMessage.value = err.response.data.error
        } else {
            errorMessage.value = 'Unexpected error occurred, kindly contact administrator'
        }
    } finally {
        isLoading.value = false
    }
}
</script>


<style scoped>

.error-message {
    color: red;
    font-size: 16px;
}

.sign-in-btn[disabled] {
    opacity: 0.7;
    cursor: not-allowed;
}
</style>
